import { createFileRoute } from '@tanstack/react-router';
import { NotesList } from '@/components/notes/notes-list';

export const Route = createFileRoute('/_authenticated/workspace/$workspaceId/notes')({
  component: NotesPage,
});

function NotesPage() {
  const { workspaceId } = Route.useParams();

  return (
    <div className="mx-auto max-w-3xl py-6">
      <NotesList workspaceId={workspaceId} />
    </div>
  );
}
